import React from 'react';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { ModalTextArea } from './ModalTextArea';
import {
  useRefillRequestModalContext,
  useStatusChangeModalContext,
} from '../utils';

export function StatusChangeModal() {
  const {
    inputValue,
    setInputValue,
    responseBox,
    onClose,
    onSuccess,
  } = useStatusChangeModalContext();

  const { isRefillRequestModalOpen, closeRefillRequestModal } =
    useRefillRequestModalContext();

  const handleStatusChangeConfirmation = () => {
    onSuccess();
    if (isRefillRequestModalOpen) closeRefillRequestModal();
  };

  return (
    <Modal
      isOpen={!!responseBox.showResponse}
      toggle={onClose}
      className="alert-modal modal-dialog--confirm status-change-confirm-modal"
    >
      {responseBox.message ? (
        <div className="modal__header">
          <span dangerouslySetInnerHTML={{ __html: responseBox.message }} />
        </div>
      ) : null}
      <div className="modal__body">
        <div className="status-change-confirmation-container">
          <ModalTextArea
            inputValue={inputValue}
            setInputValue={setInputValue}
            title="Message to Pet Parent (optional)"
            placeholder="Enter an optional message for the Pet Parent…"
          />
        </div>
      </div>
      {responseBox.responseFooter ? (
        <ButtonToolbar className="modal__footer">
          <Button className="btn-no" onClick={onClose}>
            No
          </Button>
          <Button className="btn-yes" onClick={handleStatusChangeConfirmation}>
            Yes
          </Button>
        </ButtonToolbar>
      ) : null}
    </Modal>
  );
}
